import UserRegistrationDataInterface from "@app/Interface/UserRegistrationDataInterface";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import axios from "@app/Security/AxiosAuthentication";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class RegistrationHelper {

    static submitUserRegistration = async (userId: number, data: UserRegistrationDataInterface): Promise<number> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + String(ApiEndpoints.USER_REGISTRATION).replace("{0}", String(userId));

        const config = {
            withCredentials: true,
        }

        try {

            const response = await axios.post(url, data, config);

            return response.status;
            
        } catch (error) {

            let responseCode = 500;

            if (axios.isAxiosError(error)) {

                responseCode = error.response?.status ?? 500;

            }

            RollbarHelper.logRequestError(error, "submitUserRegistration()");

            return responseCode;

        }

    }

}